export default {"src":"/_next/static/media/icon-clock.e3b859a5.svg","height":1600,"width":1600};